import { Text } from '@zillow/constellation-10';

import { css } from '@/styled-system/css';
import { shimmerStyles } from '../styles/ShimmerStyles';

import type { TextPropsInterface } from '@zillow/constellation-10';

export const LoadingText = ({
  isLoading,
  loadingWidth,
  children,
  css: cssProp,
  style: styleProp,
  asChild,
  ...rest
}: {
  isLoading: boolean;
  loadingWidth?: string;
} & Omit<TextPropsInterface, 'ref'>) => (
  <Text
    data-loading={isLoading || null}
    css={css.raw(cssProp, shimmerStyles, {
      _loading: { display: 'inline-block', marginTop: cssProp?.marginTop ?? 'micro.default' },
    })}
    style={isLoading ? { width: loadingWidth ? loadingWidth : '100%', ...styleProp } : { ...styleProp }}
    {...(isLoading ? { ...rest } : { ...rest, asChild })}
  >
    {isLoading ? <span aria-hidden="true">&nbsp;</span> : children}
  </Text>
);
